const en = {
  nav: {
    home: "Home",
    register: "Sign Up",
    login: "Sign In",
    support: "Support",
    pricing: "Pricing",
  },
  home: {
    hero_badge: "Azerbaijan's Premium Email Platform",
    hero_title_1: "Take Your",
    hero_title_2: "Email to the",
    hero_title_3: "Next Level",
    hero_subtitle: "Modern design, powerful security, trilingual support. Completely transform your email experience with emailaze.",
    hero_cta: "Start Free",
    hero_login: "Sign In",
    trust1: "AES-256 Encryption",
    trust2: "99.9% Uptime",
    trust3: "GDPR Compliant",
    logos_label: "Trusted by Companies",
    features_badge: "Why emailaze?",
    features_title: "Everything Thought Through",
    features_subtitle: "Every feature you need, a platform without what you don't.",
    feature1_title: "Complete Security",
    feature1_desc: "End-to-end AES-256 encryption. All your data is fully protected, no third-party access.",
    feature2_title: "Lightning Performance",
    feature2_desc: "Ultra-low latency thanks to local servers in Baku. Your emails arrive instantly.",
    feature3_title: "3 Language Support",
    feature3_desc: "Full support in Azerbaijani, English, and Russian. You choose, we adapt.",
    feature4_title: "Smart Filtering",
    feature4_desc: "AI-based spam filter. 99.8% accuracy spam detection, important emails always arrive.",
    how_badge: "How It Works",
    how_title: "Get Started in 3 Steps",
    how_subtitle: "Open your email account in just 5 minutes.",
    step1_num: "01",
    step1_title: "Register",
    step1_desc: "60-second registration with name, email, and password. No credit card required.",
    step2_num: "02",
    step2_title: "Set Up Your Account",
    step2_desc: "Connect your email to the @emailaze.com domain. You can also add your own domain.",
    step3_num: "03",
    step3_title: "Start Using",
    step3_desc: "Use from your browser, mobile app, or any device with IMAP/SMTP.",
    stats_badge: "emailaze by numbers",
    stats_title: "Trusted by Thousands of Users",
    stats_desc: "Join Azerbaijan's fastest growing email platform.",
    stat1_num: "50,000+",
    stat1_label: "Active Users",
    stat2_num: "99.9%",
    stat2_label: "Server Availability",
    stat3_num: "24/7",
    stat3_label: "Technical Support",
    stat4_num: "< 50ms",
    stat4_label: "Average Latency",
    reviews_badge: "User Reviews",
    reviews_title: "They've Already Chosen",
    cta_title: "Elevate Your Email Today",
    cta_subtitle: "Start with the free plan. No credit card required.",
    cta_btn: "Start Now — Free",
  },
  login: {
    title: "Welcome Back",
    subtitle: "Sign in to your emailaze account",
    email: "Email address",
    email_placeholder: "name@emailaze.com",
    password: "Password",
    password_placeholder: "Enter your password",
    remember: "Remember me",
    forgot: "Forgot password?",
    btn: "Sign In",
    or: "or",
    no_account: "Don't have an account?",
    register_link: "Sign up",
    secure: "SSL encrypted secure connection",
  },
  register: {
    title: "Create Account",
    subtitle: "Take your email to a new level with emailaze",
    firstname: "First name",
    lastname: "Last name",
    email: "Email address",
    email_placeholder: "name.surname@emailaze.com",
    phone: "Phone number",
    phone_placeholder: "+994 50 000 00 00",
    password: "Password",
    password_placeholder: "At least 8 characters",
    confirm_password: "Confirm password",
    confirm_password_placeholder: "Re-enter password",
    terms: "I accept the terms of service and privacy policy",
    terms_link: "Terms",
    btn: "Create Account",
    already: "Already have an account?",
    login_link: "Sign In",
    feature1: "Free plan — no credit card required",
    feature2: "Full protection with AES-256 encryption",
    feature3: "AZ, EN, RU language support",
    feature4: "Access from any device",
    error_password: "Passwords don't match",
    error_terms: "You must accept the terms",
    success: "Account created!",
    success_msg: "A confirmation link has been sent to your email.",
  },
  pricing: {
    hero_tag: "Transparent Pricing",
    hero_title: "Choose Your Plan",
    hero_subtitle: "All plans include AES-256 encryption, 24/7 support, and 99.9% uptime.",
    monthly: "Monthly",
    annual: "Annual",
    annual_badge: "20% off",
    popular: "Most Popular",
    plan1_name: "Free",
    plan1_desc: "Ideal for getting started",
    plan1_price_monthly: "₼0",
    plan1_price_annual: "₼0",
    plan2_name: "Pro",
    plan2_desc: "For individuals and small teams",
    plan2_price_monthly: "₼15",
    plan2_price_annual: "₼12",
    plan3_name: "Business",
    plan3_desc: "For large teams and corporations",
    plan3_price_monthly: "₼49",
    plan3_price_annual: "₼39",
    per_month: "/mo",
    get_started: "Get Started",
    contact_sales: "Contact Sales",
    feature_table_title: "Plan Comparison",
    feature_table_subtitle: "Compare features across all plans",
    cta_title: "Haven't Decided Yet?",
    cta_subtitle: "Our team will help you choose the right plan.",
    cta_btn: "Talk to an Expert",
  },
  support: {
    hero_title: "How Can We Help?",
    hero_placeholder: "Type your question...",
    channel1_title: "Phone Support",
    channel1_num: "+994 12 000 00 00",
    channel1_hours: "Weekdays 09:00 - 18:00",
    channel2_title: "Email Support",
    channel2_addr: "support@emailaze.com",
    channel2_time: "Response within 24 hours",
    channel3_title: "Live Chat",
    channel3_btn: "Start Now",
    channel3_status: "Currently active",
    faq_title: "Frequently Asked Questions",
    faq_subtitle: "Answers to the most common questions",
    form_title: "Write to Us",
    form_name: "Full Name",
    form_email: "Email",
    form_subject: "Subject",
    form_message: "Your Message",
    form_btn: "Send",
    form_success: "Message sent! We'll reply soon.",
  },
  footer: {
    desc: "emailaze.com — A modern, fast and secure email hosting platform for Azerbaijani citizens.",
    product: "PRODUCT",
    pricing_link: "Pricing",
    features: "Features",
    security: "Security",
    company: "COMPANY",
    about: "About",
    blog: "Blog",
    careers: "Careers",
    help: "SUPPORT",
    support_link: "Support Center",
    contact: "Contact",
    docs: "Documentation",
    legal: "LEGAL",
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    gdpr: "GDPR",
    copyright: "© 2026 emailaze. All rights reserved.",
  },
};

export default en;
